<h2 mat-dialog-title>Select the test variations</h2>
<mat-dialog-content>

  <ng-template #loadingGeneral>
    <mat-spinner class="center"></mat-spinner>
    <p class="center">Loading...</p>
  </ng-template>


  <div class="container" *ngIf="!loading else loadingGeneral">
    <ng-container *ngIf="!isErrorVariationsLoaded">
      <div class="choiceInterface">
      <div *ngFor="let v of variations; index as i">
          <h5>{{v.testname}}</h5>
          <p>{{v.testdescription}}</p>
          <mat-radio-group aria-label="Select an option" [(ngModel)]="checkedInterface" (change)="onRadioClick(v.testschema, v.testname, v.ifaceBox)" name="{{v.testname}}">
            <ng-container *ngFor="let iface of v.ifaces">
              <mat-radio-button [value]="iface">{{iface.iname +' (' + iface.box_name + ')'}}</mat-radio-button>
            </ng-container>
          </mat-radio-group>
      </div>
    </div>
    </ng-container>
    <ng-container *ngIf="isErrorVariationsLoaded">
      <p>Error retrieving tests variations</p>
    </ng-container>
    <div>
      <ng-template #loadingFormDiv>
        <mat-spinner class="center"></mat-spinner>
        <p class="center">Loading...</p>
      </ng-template>

     <ng-container  *ngIf="!loadingForm else loadingFormDiv">
      <ng-container *ngIf="!isErrorFormLoaded">
        <form *ngIf="selectedForm" [formGroup]="form" (ngSubmit)="onSubmit()">
          <formly-form 
            [form]="form" 
            [fields]="selectedForm" 
            [model]="model">
          </formly-form>
          <button type="submit" color="primary" (submit)="onSubmit()" mat-raised-button>
            Save
          </button>
        </form>
      </ng-container>
      <ng-container *ngIf="isErrorFormLoaded">
        <p>Error retriving test form</p>
      </ng-container>
     </ng-container>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="compiledForms" cdkFocusInitial>Close</button>
</mat-dialog-actions>


